//LOCAL SET UP
// let server_url="http://127.0.0.1:8001";
// let backend_url=server_url+'';
// let assets_url='http://localhost:8080/';
// let server_client_secret="jH4nVdYZfkkXg7imAK6jdvt1y5TohLP0RzDoD3NI";
// let router_base='/';

//LOCAL SET UP BUILD
// let server_url="http://192.168.254.100";
// let backend_url=server_url+'/franco_construction_v2/back_dev/public';
// let assets_url='http://192.168.254.100/franco_construction_v2/build/';
// let server_client_secret="jH4nVdYZfkkXg7imAK6jdvt1y5TohLP0RzDoD3NI";
// let router_base='/franco_construction_v2/build/';

//LIVE SET UP LOCAL
// let server_url="http://192.168.0.101";
// let backend_url=server_url+'/franco_construction_v2/back_dev/public';
// let assets_url='http://192.168.0.101/franco_construction_v2/build/';
// let server_client_secret="jH4nVdYZfkkXg7imAK6jdvt1y5TohLP0RzDoD3NI";
// let router_base='/franco_construction_v2/build/';

//LIVE SET UP SERVER
// let server_url="http://159.223.76.209:8880";
// let backend_url=server_url;
// let assets_url='http://159.223.76.209:8870/';
// let server_client_secret="jH4nVdYZfkkXg7imAK6jdvt1y5TohLP0RzDoD3NI";
// let router_base='/';

//LIVE SET UP SERVER STAGING
let server_url="https://api-staging.cems-rcsdc.com";
let backend_url=server_url;
let assets_url='https://staging.cems-rcsdc.com/';
let server_client_secret="jH4nVdYZfkkXg7imAK6jdvt1y5TohLP0RzDoD3NI";
let router_base='/';




export const assets_path = Object.freeze({
    DEFAULT_URL: assets_url,
    EMPLOYEE_LOGS_URL: backend_url + "/storage/uploads/site_timelogs/",
    OFFICE_LOGS_URL: backend_url + "/storage/uploads/office-timelogs/",
    // Employee photos - UploadFolders::EMPLOYEES, served by MediaController.
    MANPOWERS: backend_url + "/storage/uploads/employees/"
});
export const company_details = Object.freeze({
    NAME: "RNMK CONSTRUCTION, SUPPLY AND DEVELOPMENT CORPORATION",
    SHORT_NAME: "RNMK CONSTRUCTION, SUPPLY AND DEVELOPMENT CORP",
});
export const client_details = Object.freeze({
    CLIENT_ID: "2",
    CLIENT_SECRET: server_client_secret
});
export const server_details = Object.freeze({
    SERVER_URL: backend_url+"/api/",
    BASE_SERVER_URL: backend_url,
    ROUTER_BASE: router_base,
});
export const roles = Object.freeze({
    SUPER_ADMIN: "1",
    ADMIN: "2",
    ENCODER: "3",
    TIMEKEEPER: "4",
});